/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useRetracked } from 'js/lib/retracked';

import { Link, PageNotification } from '@coursera/cds-core';

import localStorageEx from 'bundles/common/utils/localStorageEx';
import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import useStudentSuccessAttributes from 'bundles/degree-home/components/v3-dpm/lib/useStudentSuccessAttributes';

export const DEGREE_DISCLAIMER = 'show_degree_disclaimer';

const styles = {
  container: css`
    margin-bottom: var(--cds-spacing-400);
  `,
};

export const DegreeDisclaimer = () => {
  const { degreeId } = useDegreeContext();
  const track = useRetracked();
  const { studentSuccessAttributes } = useStudentSuccessAttributes();
  const showDisclaimerLocalStorage = localStorageEx.getItem(
    `${DEGREE_DISCLAIMER}-${degreeId}`,
    JSON.parse,
    true,
    false,
    false
  );
  const disclaimerConfigEnabled = studentSuccessAttributes?.disclaimersConfig.enabled || false;
  const isNotificationVisible = disclaimerConfigEnabled && showDisclaimerLocalStorage;
  const [showNotification, setShowNotification] = React.useState<boolean>(isNotificationVisible);

  React.useEffect(() => {
    setShowNotification(isNotificationVisible);
  }, [isNotificationVisible]);

  const trackButton = React.useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    (name: string) => {
      track({
        action: 'click',
        trackingName: name,
        trackingData: {
          degreeId,
        },
      });
    },
    [degreeId, track]
  );

  const setHideDisclaimerLocalStorage = React.useCallback<() => $TSFixMe>(() => {
    localStorageEx.setItem(`${DEGREE_DISCLAIMER}-${degreeId}`, false, JSON.stringify);
  }, [degreeId]);

  const handleDismissClick = () => {
    setShowNotification(false);
    setHideDisclaimerLocalStorage();
    trackButton('dismiss');
  };

  if (!showNotification || !studentSuccessAttributes) return null;

  const { disclaimersConfig } = studentSuccessAttributes;
  const { disclaimerMessage, disclaimerCallToAction, disclaimerUrl } = disclaimersConfig;

  return (
    <PageNotification severity="information" onDismiss={handleDismissClick} css={styles.container}>
      <React.Fragment>
        {disclaimerMessage}{' '}
        {disclaimerCallToAction && disclaimerUrl && (
          <Link onClick={() => trackButton('disclaimer_call_to_action')} href={disclaimerUrl} target="_blank">
            {disclaimerCallToAction}
          </Link>
        )}
      </React.Fragment>
    </PageNotification>
  );
};

export default DegreeDisclaimer;
